<template>
  <div>
    <Title :pages="[{ icon: 'scale-balanced', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-4 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="hasta_menu"
                    v-model="hasta_menu"
                    :close-on-content-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Al" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" :disabled="!emitter_selected" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Estado de Situación Patrimonial -->
      <v-card>
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" small outlined class="mr-2" :disabled="loading || !data" @click="toggleAll">
            {{ allExpanded ? "Colapsar todo" : "Expandir todo" }}
          </v-btn>
          <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        </v-card-title>

        <v-progress-linear v-if="loading" indeterminate color="info"></v-progress-linear>

        <div class="pa-2" style="overflow-x: auto">
          <div v-if="loading" class="pa-6 text-center grey--text">Cargando...</div>

          <div v-else-if="data">
            <v-alert v-if="!data.totales.cuadra" type="error" dense text class="mx-2">
              El Activo no coincide con Pasivo + Patrimonio Neto (diferencia {{ formatUtils.formatPrice(data.totales.diferencia) }}). Revisá el Libro Diario.
            </v-alert>

            <div class="row">
              <!-- Activo -->
              <div class="col-md-6">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr class="blue lighten-5">
                        <th class="text-left">ACTIVO</th>
                        <th class="text-right"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="row in rowsBySeccion.activo"
                        :key="'a-' + row.item.account_id"
                        :style="row.hasChildren ? 'cursor:pointer' : ''"
                        @click="row.hasChildren && toggle(row.item.account_id)"
                      >
                        <td :style="{ paddingLeft: 8 + row.depth * 20 + 'px' }">
                          <v-icon v-if="row.hasChildren" small class="mr-1">{{ row.expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                          <span :class="{ 'font-weight-bold': row.hasChildren }">{{ row.item.label }}</span>
                        </td>
                        <td class="text-right" :class="{ 'font-weight-bold': row.hasChildren }">{{ formatUtils.formatPrice(row.item.importe) }}</td>
                      </tr>
                      <tr v-if="data.activo.cuentas.length === 0">
                        <td colspan="2" class="text-center grey--text py-2">Sin saldos.</td>
                      </tr>
                      <tr class="grey lighten-3">
                        <td class="font-weight-bold">TOTAL ACTIVO</td>
                        <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.activo.total) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- Pasivo + Patrimonio Neto -->
              <div class="col-md-6">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr class="blue lighten-5">
                        <th class="text-left">PASIVO</th>
                        <th class="text-right"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="row in rowsBySeccion.pasivo"
                        :key="'p-' + row.item.account_id"
                        :style="row.hasChildren ? 'cursor:pointer' : ''"
                        @click="row.hasChildren && toggle(row.item.account_id)"
                      >
                        <td :style="{ paddingLeft: 8 + row.depth * 20 + 'px' }">
                          <v-icon v-if="row.hasChildren" small class="mr-1">{{ row.expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                          <span :class="{ 'font-weight-bold': row.hasChildren }">{{ row.item.label }}</span>
                        </td>
                        <td class="text-right" :class="{ 'font-weight-bold': row.hasChildren }">{{ formatUtils.formatPrice(row.item.importe) }}</td>
                      </tr>
                      <tr v-if="data.pasivo.cuentas.length === 0">
                        <td colspan="2" class="text-center grey--text py-2">Sin saldos.</td>
                      </tr>
                      <tr class="grey lighten-3">
                        <td class="font-weight-bold">TOTAL PASIVO</td>
                        <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.pasivo.total) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-simple-table dense class="mt-2">
                  <template v-slot:default>
                    <thead>
                      <tr class="blue lighten-5">
                        <th class="text-left">PATRIMONIO NETO</th>
                        <th class="text-right"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="row in rowsBySeccion.patrimonio_neto"
                        :key="'pn-' + row.item.account_id"
                        :style="row.hasChildren ? 'cursor:pointer' : ''"
                        @click="row.hasChildren && toggle(row.item.account_id)"
                      >
                        <td :style="{ paddingLeft: 8 + row.depth * 20 + 'px' }">
                          <v-icon v-if="row.hasChildren" small class="mr-1">{{ row.expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                          <span :class="{ 'font-weight-bold': row.hasChildren }">{{ row.item.label }}</span>
                        </td>
                        <td class="text-right" :class="{ 'font-weight-bold': row.hasChildren }">{{ formatUtils.formatPrice(row.item.importe) }}</td>
                      </tr>
                      <tr v-if="mostrarResultado">
                        <td class="font-italic">Resultado del Ejercicio (en curso)</td>
                        <td class="text-right font-italic">{{ formatUtils.formatPrice(data.patrimonio_neto.resultado_ejercicio) }}</td>
                      </tr>
                      <tr class="grey lighten-3">
                        <td class="font-weight-bold">TOTAL PATRIMONIO NETO</td>
                        <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.patrimonio_neto.total) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr class="blue lighten-5">
                    <td class="font-weight-bold">TOTAL ACTIVO</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.activo) }}</td>
                  </tr>
                  <tr class="blue lighten-5">
                    <td class="font-weight-bold">TOTAL PASIVO + PATRIMONIO NETO</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.pasivo_pn) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div v-else class="pa-6 text-center grey--text">Elegí emisor y fecha de corte, y presioná Buscar.</div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import CuentasTreeMixin from "@/mixins/CuentasTreeMixin.vue";
import Title from "@/components/Title.vue";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin, CuentasTreeMixin],
  data() {
    return {
      page_title: "Estado de Situación Patrimonial",
      formatUtils: formatUtils,
      data: null,
      hasta_menu: false,
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      emitters: [],
      emitter_selected: null,
    };
  },
  computed: {
    mostrarResultado() {
      return this.data && Math.abs(this.data.patrimonio_neto.resultado_ejercicio) >= 0.01;
    },
    // Árboles sobre los que opera CuentasTreeMixin (Expandir todo / allExpanded).
    cuentasTrees() {
      return this.data ? [this.data.activo.cuentas, this.data.pasivo.cuentas, this.data.patrimonio_neto.cuentas] : [];
    },
    // Aplana cada sección respetando `expanded`, para iterarla con un solo v-for por
    // fila (cuentas padre e hijas al mismo nivel de tabla). El detalle corta en la
    // cuenta imputable: el Balance no tiene apertura por concepto.
    rowsBySeccion() {
      if (!this.data) return { activo: [], pasivo: [], patrimonio_neto: [] };
      return {
        activo: this.flattenCuentas(this.data.activo.cuentas),
        pasivo: this.flattenCuentas(this.data.pasivo.cuentas),
        patrimonio_neto: this.flattenCuentas(this.data.patrimonio_neto.cuentas),
      };
    },
  },
  mounted() {
    this.loadCombos();
  },
  methods: {
    loadCombos() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.filter();
        }
      });
    },
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        to: this.hasta_selected,
      };
    },
    filter() {
      if (this.emitter_selected == null) return;
      this.loading = true;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_BALANCE)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
          this.resetExpanded();
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_BALANCE, param, "Estado-Situacion-Patrimonial.xlsx");
    },
  },
};
</script>
